import React, { useState } from "react";
import Navbar from "../navbar/Navbar";
import { Breadcrumb, Layout } from "antd";
import "./UserHOC.css";
import { sidebarItems } from "../../../assets/constants/constants";
import SideBar from "../../global/Sidebar/SideBar";

const UserHOC = (Component) =>
  function HOC() {
    const [loading, setLoading] = useState(false);
    const [header, setHeader] = useState();
    const [breadcrumbs, setBreadCrumbs] = useState([]);
    const [hideSidebar, setHideSidebar] = useState(false);

    const [selectedId, setSelectedId] = useState(() => {
      try {
        const savedId = localStorage.getItem("selectedId");
        return savedId ? JSON.parse(savedId) : null;
      } catch (e) {
        return null;
      }
    });

    const { Header, Sider, Content } = Layout;

    return (
      <Layout className="flex flex-col h-screen overflow-y-scroll bg-white">
        {/* Navbar */}
        <Header className="p-0 h-0 bg-transparent leading-normal shrink-0 z-[999]">
          <Navbar />
        </Header>

        <div
          style={{
            marginTop:"80px",
            flexShrink: 0, 
          }}
        >

          {breadcrumbs  }
        </div>

        {/* Main Layout */}
        <Layout className="flex-1 min-h-0 px-[24px] pt-[12px] pb-[24px] bg-white">
          {/* Sidebar */}
          {!hideSidebar && (
            <Sider width="120px" className="bg-white rounded-[10px] overflow-y-auto">
              <SideBar items={sidebarItems} />
            </Sider>
          )}

          {/* Content */}
          <Content className="pl-6 pb-6">
            <Component
              loading={loading}
              setLoading={setLoading}
              setHeader={setHeader}
              setBreadCrumbs={setBreadCrumbs}
              setSelectedId={setSelectedId}
              sidebarItems={sidebarItems}
              setHideSidebar={setHideSidebar}
              selectedId={selectedId}
            />
          </Content>
        </Layout>
      </Layout>
    );
  };

export default UserHOC;